import React from 'react';
import DateFnsUtils from '@date-io/date-fns'; // choose your lib
import esLocale from "date-fns/locale/es";
import {
  DatePicker,  
  MuiPickersUtilsProvider,
} from '@material-ui/pickers';
import { Box} from '@material-ui/core'
import dayjs from "dayjs";

const Relojes2 = ({fechasSeleccionadas, setFechasSeleccionadas, }) => {
  //const [selectedDate, handleDateChange] = useState(new Date());  
  const {inicio,final}=fechasSeleccionadas  
  const diasMes=dayjs(new Date()).daysInMonth()
  const fchMax=dayjs().date(diasMes+1).format("YYYY-MM-DD")
  const guardarInicio = auxfecha =>
  {
    setFechasSeleccionadas({
      ...fechasSeleccionadas,
      inicio : auxfecha  
    })
  };
  const guardarFinal = auxfecha =>
  {
    setFechasSeleccionadas({
      ...fechasSeleccionadas,
      final : auxfecha  
    })
  };
    
    return (
    <MuiPickersUtilsProvider locale={esLocale} utils={DateFnsUtils}>    
    <Box component="span" pb={1}>
      <Box  ml={1}  component="span" width={1/4}>                                                
        <DatePicker
          //disableFuture
          //openTo="month"
          format="dd/MM/yyyy"
          views={["year", "month", "date"]}
          label="Fecha inicial"
          size="small"
          minDate="2017-03-14"
          maxDate={fchMax}
          value={inicio}
          onChange={guardarInicio}      
          style={{width:6.5+'rem'}}      
          cancelLabel={"Cancelar"} okLabel="Seleccionar"       
        />
      </Box>    
      <Box ml={1}  component="span" width="25%">
        <DatePicker
          //disableFuture
          id="final"
         // openTo="year"
          format="dd/MM/yyyy"
          label="Fecha Final"
          views={["year", "month", "date"]}
          minDate={inicio}
          maxDate={fchMax}
          value={final}
          name="final"
          size="small"
          style={{width:6.5+'rem'}}      
          onChange={guardarFinal}
          cancelLabel={"Cancelar"} okLabel="Seleccionar"       
        />
      </Box> 
  </Box>                         
    </MuiPickersUtilsProvider>
    );
}

export default Relojes2
